import { getExperts } from 'api/expert';
import * as creatorsSync from 'actions/creatorsSync';
import * as types from 'actions/types';
import { AVAILABLE } from 'constants/expertAvailability';
import { handleError, ErrorConstants } from 'services/ErrorService/ErrorService';

export const asyncHydrateAvailableExpertsForForwardingDropdown = () => async (dispatch, getState) => {
  const state = getState();
  const { nextPage, loadLimit, cursor } = state.forwardToExpert.pagination;
  const { searchParam } = state.forwardToExpert;

  const params = {
    skip: loadLimit * nextPage,
    limit: loadLimit,
    searchParam,
    availabilityState: AVAILABLE,
    isActive: true,
    isSpecialist: false,
    cursor,
  };

  try {
    const { experts, cursor: newCursor } = await getExperts(params);
    dispatch(creatorsSync.hydrateExpertsForForwardingDropdown(experts, newCursor));
  } catch (error) {
    handleError({ error, customMessage: ErrorConstants.defaultErrorRequestProblem, showPopup: true });
  }
};

export const setSearchParamForForwardingDropdownAndLoad = (searchParam) => async (dispatch, getState) => {
  const { forwardToExpert } = getState();
  if (forwardToExpert.searchParam !== searchParam) {
    dispatch({
      type: types.SET_SEARCH_PARAM_FOR_FORWARDING_DROPDOWN,
      searchParam,
    });

    await dispatch(asyncHydrateAvailableExpertsForForwardingDropdown());
  }
};

export const setSelectedExpertForForwardingDropdownAndLoad = (selectedExpert) => async (dispatch, getState) => {
  const { forwardToExpert } = getState();
  if (forwardToExpert.selectedExpert.id !== selectedExpert.id) {
    dispatch(changeSelectedExpertForForwardingDropdown(selectedExpert));

    await dispatch(asyncHydrateAvailableExpertsForForwardingDropdown());
  }
};

export const changeSelectedExpertForForwardingDropdown = (selectedExpert) => ({
  type: types.SET_SELECTED_EXPERT_FORWARDING_DROPDOWN,
  selectedExpert,
});

export const clearStateForForwardingDropdown = () => ({
  type: types.CLEAR_EXPERTS_FOR_FORWARDING_DROPDOWN,
});
